import React from 'react'
import BackButton from '@Components/Buttons/BackButton'
import ContentHeader from '@Components/ContentHeader'
import OverclaimViewHeaderDescription from '@Components/OverclaimView/Headers/OverclaimViewHeader/OverclaimViewHeaderDescription'

export interface OverclaimViewHeaderProps {
    songTitle: string
    amendingShares?: boolean
}
const OverclaimViewHeader = (props: OverclaimViewHeaderProps) => {
    const { songTitle, amendingShares } = props
    return (
        <ContentHeader
            title={songTitle + ' - Overclaim Detail'}
            navLeft={<BackButton />}
            descriptionElement={<OverclaimViewHeaderDescription amendingShares={amendingShares} />}
        />
    )
}

export default OverclaimViewHeader
